import { render, staticRenderFns } from "./MPSQ.vue?vue&type=template&id=b7951eb6&scoped=true"
import script from "./MPSQ.vue?vue&type=script&lang=js"
export * from "./MPSQ.vue?vue&type=script&lang=js"
import style0 from "./MPSQ.vue?vue&type=style&index=0&id=b7951eb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7951eb6",
  null
  
)

export default component.exports